import React from 'react';

// Aylık bülten — iki şablonun (tek sayfa bülten / sunum) ortak biçim ve form parçaları.

export const MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

// ── Biçimlendirme ───────────────────────────────────────────────────────────
// Kısa gösterim bültenin kendi kuralıyla: 10'un altı tek ondalık, üstü tam sayı,
// ondalık YUVARLANMAZ kesilir (1,77M → "1,7M"; markanın elle yaptığı bültenle aynı).
const trunc1 = (x) => Math.floor(x * 10) / 10;
export function compact(v) {
  if (v == null || !isFinite(v)) return '–';
  const a = Math.abs(v);
  const f = (x, suf) => {
    const s = x >= 10 ? String(Math.floor(x)) : String(trunc1(x)).replace('.', ',');
    return `${s}${suf}`;
  };
  if (a >= 1e9) return f(v / 1e9, 'B');
  if (a >= 1e6) return f(v / 1e6, 'M');
  if (a >= 1e3) return `${Math.round(v / 1e3).toLocaleString('tr-TR')} Bin`;
  return Math.round(v).toLocaleString('tr-TR');
}
export const money = (v) => (v == null || !isFinite(v) ? '–' : `₺${compact(v)}`);
export const moneyFull = (v) => (v == null || !isFinite(v) ? '–' : `₺${Math.round(v).toLocaleString('tr-TR')}`);
export const intFull = (v) => (v == null || !isFinite(v) ? '–' : Math.round(v).toLocaleString('tr-TR'));
export const dec = (v, d = 2) => (v == null || !isFinite(v) ? '–' : v.toFixed(d).replace('.', ','));

export function change(cur, prev) {
  if (!prev || cur == null) return null;
  return ((cur - prev) / prev) * 100;
}

// "**kalın**" işaretini <strong>'a çevirir, satır sonlarını korur.
export function RichText({ text }) {
  if (!text) return null;
  return String(text).split('\n').map((line, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br />}
      {line.split(/(\*\*[^*]+\*\*)/g).map((part, j) => (
        part.startsWith('**') && part.endsWith('**')
          ? <strong key={j}>{part.slice(2, -2)}</strong>
          : <React.Fragment key={j}>{part}</React.Fragment>
      ))}
    </React.Fragment>
  ));
}

// Sayfa başlığından okunur etiket: "Yaz Fırsatları | Enza Home" → "Yaz Fırsatları"
// Başlığı olmayan (title = alan adı) bilinen yollar
const PATH_LABELS = { '/list/': 'Tüm Ürünler', '/baskets/basket/': 'Sepet' };
export function pageLabel(p) {
  if (!p) return '';
  if (/^\/([a-z]{2}\/?)?$/.test(p.path)) return 'Ana sayfa';
  if (PATH_LABELS[p.path]) return PATH_LABELS[p.path];
  const t = String(p.title || '').split(/ [|–-] /)[0].trim();
  if (t && !/^www\.|\.com/i.test(t)) return t;
  const seg = p.path.split('/').filter(Boolean).pop() || p.path;
  return seg.replace(/-/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

// ── Düzenlenebilir parçalar ─────────────────────────────────────────────────
export const editBox = 'outline outline-2 outline-dashed outline-amber-400/80 outline-offset-2 rounded';

export function TextField({ editing, value, onChange, placeholder, multiline, rows = 4, className = '', inputClass = '' }) {
  if (!editing) return null;
  const common = `w-full bg-white/95 text-gray-900 text-sm rounded border border-amber-300 px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-amber-400 ${inputClass}`;
  return (
    <div className={className}>
      {multiline
        ? <textarea rows={rows} className={common} value={value || ''} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
        : <input className={common} value={value || ''} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />}
    </div>
  );
}

export function NumberField({ editing, value, onChange, placeholder, className = '' }) {
  if (!editing) return null;
  return (
    <input
      type="number"
      className={`w-full bg-white text-gray-900 text-xs rounded border border-amber-300 px-2 py-1 focus:outline-none focus:ring-2 focus:ring-amber-400 ${className}`}
      value={value ?? ''}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
    />
  );
}

// Yuvarlayan kısa gösterim (Yataş Bedding sunumu: 1,68M → "1,7M")
export function compactRound(v) {
  if (v == null || !isFinite(v)) return '–';
  const a = Math.abs(v);
  const f = (x, suf) => `${x >= 10 ? Math.round(x) : String(Math.round(x * 10) / 10).replace('.', ',')}${suf}`;
  if (a >= 1e9) return f(v / 1e9, 'B');
  if (a >= 1e6) return f(v / 1e6, 'M');
  if (a >= 1e3) return f(v / 1e3, ' Bin');
  return Math.round(v).toLocaleString('tr-TR');
}
